<template>
  <div class="authority" >
    <el-row>
        <el-col>
          <el-button size="mini" type="primary" @click="memberLevelSetting">返回至客户列表</el-button>
          <a href="/setting_panel">
            <el-button type="primary" size="mini">返回上一级</el-button>
          </a>
        </el-col>
      </el-row>
    <el-row class="m-con">
      <el-col class="role-list" :span="4">
        <div class="list">
          <div class="pb15" :class="{ 'active-role': active_role === item.level_id }" v-for="(item, index) in filterRoles"
            :key="index">
            <i class="el-icon-user"></i>
            <span class="sel-role" @click="selectRole(index, item)">{{ item.level_name }}</span>
          </div>
        </div>
      </el-col>
      <el-col :span="20">
        <el-tabs v-model="activeName" @tab-click="handleTabsClick">
          <el-tab-pane label="配置权限" name="post">
            <div v-if="!active_role" class="node-empty">
              <p>暂无数据</p>
            </div>
            <div class="node-con" v-else>
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
              </el-checkbox>
              <div style="margin: 15px 0;"></div>
              <el-checkbox-group v-model="checkedAccesses" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="access in accesses" :label="access.access_id" :key="access.access_id">
                  {{ access.access_name }}</el-checkbox>
              </el-checkbox-group>
              <el-row class="tr mt10">
                <el-button type="primary" size="mini" @click="handleSaveNode">保存</el-button>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'ClientManage',
  data () {
    return {

      checkAll: false,
      checkedAccesses: [],
      accesses: [],
      isIndeterminate: true,
      activeName: 'post',
      active_role: null,
      filterRoles: []
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
  },
  methods: {
    handleTabsClick (tab, event) { },
    handleCheckAllChange (val) {
      this.checkedAccesses = val ? this.getAccessArr() : []
      this.isIndeterminate = false
    },
    getAccessArr () {
      let arr = []
      for (var i = 0; i < this.accesses.length; i++) {
        arr.push(this.accesses[i].access_id)
      }
      return arr
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.accesses.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.accesses.length
    },
    selectRole (index, row) {
      this.$axios.post('/api/admin/client_manage/accesses', { val: [row.level_id] })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            console.log(data)
            this.accesses = data.data.client_access
            this.checkedAccesses = data.data.checked_access
            // this.filterRoles = data.data.filter_level
            this.active_role = row.level_id
          }
        }
        )
    },
    handleSaveNode () {
      let checkArr = []
      for (var i = 0; i < this.checkedAccesses.length; i++) {
        checkArr.push(this.checkedAccesses[i])
      }
      this.$axios.put('/api/admin/client_manage/update_accesses', { val: [checkArr, this.active_role] })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        }
        )
    },
    getClientLevel () {
      this.$axios.get('/api/admin/client_manage/getlevel')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.filterRoles = data.data.level_data
          } else {
            this.$message.error(data.msg)
          }
        }
        )
    },
    memberLevelSetting () {
      this.$router.push({
        path: '/my_customers'
      })
    }
  },
  mounted () {
    this.getClientLevel()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .authority >>> .el-tabs__header
    padding-left: .4rem
  .authority >>> .el-tabs__nav-wrap::after
    display:none !important
  .el-checkbox.is-bordered
    margin-bottom: .2rem
  .authority
    marginLeft()
    .m-con
      background-color: #fff
      border-radius: .2rem .2rem 0 0
    .mtb30
      margin-bottom: .6rem
    .mt10
      margin-top: .2rem
    .pb15
      padding-bottom: .3rem
    .role-list
      min-height: calc(100vh - 210px)
      padding-right: 12px
      border-right: 1px solid #ebebeb
      .list
        margin-top: .3rem
    .more-icon
      float: right
      color: #5789F4
      cursor: pointer
    .sel-role
      cursor: pointer
    .active-role
      color: #5789f4
    .node-header
      line-height: .88rem
      padding-left: .4rem
      margin-bottom: .3rem
      color: #5789F4
    .node-empty
      text-align: center
      color: rgba(0, 0, 0, .3)
    .node-con
      padding-left: .4rem
    .check-title
      margin-right: .4rem
    .tr
      text-align: right
    .el-checkbox.is-bordered+.el-checkbox.is-bordered
      margin-left: 0
    .el-checkbox
      margin-bottom: .2rem
</style>



// WEBPACK FOOTER //
// src/pages/client_manage/ClientManage.vue